import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from 'react-router-dom';
import send from '../assets/send.png'
import { faArrowLeft, faUser } from "@fortawesome/free-solid-svg-icons";
import {toast} from "react-toastify";
import CustomToastContainer from "../components/CustomToastContainer";
import { getThread, registerComplaint } from "../apiServices/apiServices";
import ThreadMessage from "../components/ThreadMessage";
import moment from "moment";

const ComplaintDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(window.localStorage.getItem("user"));
  const [data, setData] = useState([])
  const [replies, setReplies] = useState([])
  const [msg, setMsg] = useState("")
  const parentComplaint = location.state

  console.log("Parent Complaint: ", parentComplaint)

  useEffect(() => {
    fetchThread();

    const interval = setInterval(() => {
        fetchThread();
    }, 10000);

    return () => clearInterval(interval); 
}, []);
const handleSubmit = async () => {
  if (msg == "") {
    toast.warn('Please enter message.');
    return;
  }

  var details = msg
  var is_active = 1
  var subject = "REPLY"
  var typeid = 0
  var passenger_id = user.id
  var parent_id = parentComplaint.id
  var type = "REPLY"

  try {
      const response = await registerComplaint( typeid, passenger_id, parent_id, type, subject, details, is_active );
      console.log("Response : ", response);
      if (response && response.success) {
        setMsg("")
        fetchThread()
      } else {
        toast.error(response.message || 'Message sending failed');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('An error occurred. Please try again.');
    }

  
};

const fetchThread = async () => {
  try {
      const response = await getThread(parentComplaint.id);
      console.log("Response of thread:", response);
      if (response && response.success) {
        const res = response.data
        if (res && res.complaint){
        const sortedReplies = response.data?.complaint?.filter(c => c?.parent_id === parentComplaint.id).sort((a, b) => new Date(a?.created_at) - new Date(b?.created_at)); // Sorting by createdAt date

        setReplies(sortedReplies);
        console.log("Replies: ", sortedReplies)
        setData(response.data?.complaint.find(c => !c.parent_id));
        } else {
          toast.error(response.message || 'Failed to fetch conversation');
        }
      } else {
        toast.error(response.message || 'Failed to fetch conversation');
      }
      
  } catch (error) {
      console.error('Error fetching thread:', error);
  } finally {
  }
};

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
      <div className=" w-full h-screen flex flex-col bg-gray-100">
        {/* Scrollable Content */}
        <div className="flex-grow overflow-y-auto mb-20">
          <div className="space-y-6">
            {/* Header */}
            <div className="flex items-start p-4">
              <button className="text-gray-600 items-center" onClick={() => handleNavigation(-1)}>
                <FontAwesomeIcon icon={faArrowLeft} size="lg" />
              </button>
              <div className="flex items-center space-x-4 ml-4">
                <div className="w-12 h-12 bg-gray-200 rounded-full border border-gray-700 flex items-center justify-center p-2">
                  <FontAwesomeIcon
                    icon={faUser}
                    className="object-cover w-full h-full text-gray-700 md:p-4"
                  />
                </div>
                <div>
                  <p className="text-base sm:text-lg font-medium md:font-large text-gray-800">{parentComplaint.passenger}</p>
                  <p className="text-sm md:font-medium text-gray-500">{moment(parentComplaint.created_at).format("DD MMM yyyy hh:mm A")}</p>
                </div>
              </div>
            </div>

            {/* Complaint Section */}
            <div className="px-4">
              <p className="text-base md:text-lg text-gray-500">COMPLAINT:</p>
              <p className="mt-2 text-sm md:text-base text-gray-800">{parentComplaint.details}</p>
            </div>

            {/* Replies Section */}
            <div className="mb-15">
              <p className="text-base md:text-lg text-gray-500 px-4">REPLIES:</p>
              <div className="mt-2 h-px bg-gray-300 "></div>
              {/* Placeholder for replies */}
              <div className="mt-4 space-y-2 overflow-y-auto w-full flex-grow bg-gray-100 px-4">
                {/* Replace with dynamic reply components */}
                {replies && replies.map((item) => (
                  <ThreadMessage isUser={item.passenger_id === parentComplaint.passenger_id} username={(item.passenger === user.fullname)? "Me" : "PSBS Support"} message={item.details} time={item.created_at} />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Input */}
        <div className=" w-full bg-gray-200 p-4 flex items-center fixed bottom-0 left-0 right-0 z-10 ">
          <input
            type="text"
            placeholder="Type here..."
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
            className="flex-grow h-10 px-4 border border-gray-300 rounded-lg text-sm md:text-base text-gray-700 placeholder-gray-400 focus:outline-none focus:ring focus:ring-gray-300"
          />
          <button className="ml-4 w-10 h-10 bg-[#BE1F18] rounded-full flex items-center justify-center p-2" onClick={handleSubmit}>
            <img src={send} alt="Send" />
          </button>
        </div>
      </div>
      <CustomToastContainer/>
    </>
  );
};

export default ComplaintDetail;
